import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import VueLazyLoad from 'vue-lazyload'
import VeeValidate, { Validator } from 'vee-validate'
import { Uploader } from 'vant';
Vue.use(VueLazyLoad, {
        // error: require('./statics/imgs/erry.jpg'),
        // loading: require('./statics/imgs/load.gif')
        throttleWait: 5000
    })
    // import Utils from '@/utils/index'
Vue.use(Uploader);
import lang from '@/utils/lang'
import moment from 'moment'
Vue.prototype.moment = moment
let curlang = ""
var apptype = navigator.appName
if (apptype == "Netscape") {
    curlang = navigator.language; //获取浏览器配置语言，支持非IE浏览器
} else {
    curlang = navigator.userLanguage; //获取浏览器配置语言，支持IE5+ == navigator.systemLanguage
}
if (curlang != "zh-cn") {
    curlang = "ru"
}

Vue.prototype.rule_required= { trigger: "onBlur", required: true, message: "*" }

Vue.prototype.LangType = 'cn' // curlang
if (Vue.prototype.LangType == 'ru') {
    // console.log(1)
    Vue.prototype.$lang = lang.ru
} else {
    // console.log(2)
    Vue.prototype.$lang = lang.zh_cn
}

// Vue.prototype.$utils = Utils
// Utils.install();
export const eventBus = new Vue()
    // VANT
import Vant from 'vant'

import 'vant/lib/index.css'
// import { Dialog } from 'vant';

// // 全局注册
// Vue.use(Dialog);
Vue.use(Vant)

import Meta from "vue-meta";
Vue.use(Meta);

const formatFileSize = function (size) {
    let units = ['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    let threshold = 1024;
    size = Number(size) * threshold;
    let i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(threshold));
    return (((size / Math.pow(threshold, i)).toFixed(2) * 1) + " " + (units[i]));
   }
   
// 首先npm i amfe-flexible --save
import 'amfe-flexible/index.js'
//  amfe-flexible rem适配
// vue实例中挂载Apis
import Request from '@/api/apis';
Vue.prototype.$request = Request;
Vue.prototype.$imgpath = Request.imgpath;
// console.log(Vue.prototype.$imgpath(22))
    // 适配
import 'amfe-flexible/index.js'
Vue.config.productionTip = false
    //复制内容至剪切板插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
import filters from './filter/filter'
//过滤器统一处理加载
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')